export default [
	{ value: 1, text: 'Niemand aanwezig' },
	{ value: 2, text: 'Geen medewerking interieur / wel exterieur' },
	{ value: 3, text: 'Geen medewerking interieur en exterieur' },
	{ value: 4, text: 'Niet toegankelijk' },
	{ value: 5, text: 'Gesloten' },
	{ value: 6, text: 'Leegstaand' },
	{ value: 7, text: 'Geen gehoor' },
	{ value: 8, text: 'Deurbel / intercom defect' },
	{ value: 9, text: 'Geen tijd voor opname' },
	{ value: 10, text: 'Taalbarriere' },
	{ value: 11, text: 'In steigers' },
	{ value: 12, text: 'In verbouwing' },
	{ value: 13, text: "Niet van toepassing" },
	{ value: 14, text: "afwezig ondanks afspraak" }
]